import {Translate} from 'react-redux-i18n';
import PropTypes from 'prop-types';
import {Icon, TextPhoneNumber, AbstractFormComponent} from 'front-onceforall-core';
import {requiredValidator, emailValidator, phoneNumberValidator} from 'front-onceforall-core/dist/utils/validators';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import {connect} from 'react-redux';
import {errorType} from '../../../utils/constant';
import {availableLanguages} from '../../../translations';
import {captureError} from '../../../utils/log';
import {getPhoneLocaleFromCountry} from '../../../utils/country';

export class InviteUserForm extends AbstractFormComponent {
  constructor(props) {
    super(props);

    this.state = {...this.state, defaultPhoneCountry: getPhoneLocaleFromCountry(props.organisation.country)};

    this.changeCustomMessage = this.changeCustomMessage.bind(this);
  }

  getFormData() {
    return {
      email: this.props.userMail,
      firstName: '',
      lastName: '',
      language: this.props.currentLocale,
      customMessage: '',
      phoneNumber: ''
    };
  }

  getFormValidators() {
    return {
      email: [requiredValidator, emailValidator],
      firstName: requiredValidator,
      lastName: requiredValidator,
      language: requiredValidator,
      customMessage: requiredValidator,
      phoneNumber: [requiredValidator, phoneNumberValidator]
    };
  }

  componentDidMount() {
    this.changeCustomMessage(this.props.currentLocale);
    this.setState({loading: false});
  }

  handleChangeCallback(name, value) {
    if (name === 'language') {
      this.changeCustomMessage(value);
    }
  }

  changeCustomMessage(language) {
    const {formData} = this.state;
    formData.customMessage = this.props.translateInvitationMessage(language);
    this.setState({
      formData
    });
  }

  handleSubmitCallback() {
    // Replace \n with <br />
    const formData = {
      ...this.state.formData, customMessage: this.state.formData.customMessage.replace(/\n/g, '<br />')};

    this.props.onValidate(formData)
      .catch(error => {
        if (error && error.type &&
            (error.type === errorType.INVITATION_ALREADY_SENT || error.type === errorType.USER_ALREADY_IN_ORGANISATION)) {
          const {fieldErrors} = this.state;
          fieldErrors.email = error.message;
          this.setState({fieldErrors, submitting: false});
          return;
        }

        captureError('this.props.onValidate: unhandled exception', error);
        this.props.actions.addError(<Translate value="error.generic"/>);
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <h2><Translate value={this.props.panelTitle}/></h2>
        <TextField
          label={this.getFieldLabel('invite.email', true)}
          value={this.state.formData.email}
          onChange={this.handleChange('email')}
          error={this.isOnError('email')}
          helperText={this.helperText('email')}
        />
        <div className="row">
          <div className="col-md-6">
            <TextField
              autoFocus
              label={this.getFieldLabel('invite.firstName', true)}
              value={this.state.formData.firstName}
              onChange={this.handleChange('firstName')}
              error={this.isOnError('firstName')}
              helperText={this.helperText('firstName')}
            />
          </div>
          <div className="col-md-6">
            <TextField
              label={this.getFieldLabel('invite.lastName', true)}
              value={this.state.formData.lastName}
              onChange={this.handleChange('lastName')}
              error={this.isOnError('lastName')}
              helperText={this.helperText('lastName')}
            />
          </div>
        </div>

        <TextPhoneNumber
          label={this.getFieldLabel('invite.phoneNumber', true)}
          value={this.state.formData.phoneNumber}
          onChange={this.handleChange('phoneNumber')}
          error={this.isOnError('phoneNumber')}
          helperText={this.helperText('phoneNumber')}
          defaultLocal={this.state.defaultPhoneCountry}
          currentLocale={this.props.currentLocale}
        />

        <TextField
          select
          label={this.getFieldLabel('invite.language', true)}
          value={this.state.formData.language}
          onChange={this.handleChange('language')}
          error={this.isOnError('language')}
          helperText={this.helperText('language')}
          data-id="language"
        >
          {availableLanguages.map((lang, index) => (
            <MenuItem
              key={index}
              value={lang}
            ><Translate value={`language.${lang}`}/></MenuItem>
          ))}
        </TextField>

        <TextField
          multiline
          rows={17}
          label={this.getFieldLabel('invite.customMessage', true)}
          value={this.state.formData.customMessage}
          onChange={this.handleChange('customMessage')}
          error={this.isOnError('customMessage')}
          helperText={this.helperText('customMessage')}
        />

        <div className="actions col-12 inline-container space-between">
          <button
            type="button"
            className="large secondary inline-container"
            onClick={this.props.onCancel}
            data-id="cancel"
          >
            <Icon icon="go-back"/>
            <Translate value="action.cancel"/>
          </button>
          <button
            className="large primary inline-container"
            type="submit"
            disabled={this.state.submitting}
          >
            <Icon icon={this.state.submitting ? 'loader' : 'paper-plane'}/>
            <Translate value="action.confirm"/>
          </button>
        </div>
      </form>
    );
  }
}

InviteUserForm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  actions: PropTypes.object.isRequired,
  onValidate: PropTypes.func.isRequired,
  userMail: PropTypes.string.isRequired,
  translateInvitationMessage: PropTypes.func.isRequired,
  currentLocale: PropTypes.string.isRequired,
  organisation: PropTypes.object.isRequired,
  panelTitle: PropTypes.string.isRequired
};

function mapStateToProps(state) {
  return {
    organisation: state.organisation
  };
}

export default connect(mapStateToProps)(InviteUserForm);
